import { render, staticRenderFns } from "./CustomFieldUser.vue?vue&type=template&id=303e45e2"
import script from "./CustomFieldUser.vue?vue&type=script&lang=js"
export * from "./CustomFieldUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports